import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["wrapperStyle", "iconStyle"];
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { useState, useEffect } from 'react';
import { getCountryCallingCode, isValidPhoneNumber as validatePhoneNumber } from 'react-phone-number-input';
import CountriesMenu from '../countries-menu';
import { TextInput } from '../text-input';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function PhoneInput(_ref) {
  var textInput = _ref.textInput,
      countriesMenu = _ref.countriesMenu,
      onChange = _ref.onChange,
      id = _ref.id,
      _ref$defaultCountry = _ref.defaultCountry,
      defaultCountry = _ref$defaultCountry === void 0 ? 'IT' : _ref$defaultCountry;

  var _ref2 = countriesMenu || {},
      countryMenuWrapperStyle = _ref2.wrapperStyle,
      favorites = _ref2.favorites;

  var _ref3 = textInput || {},
      inputWrapperStyles = _ref3.wrapperStyle,
      iconStyle = _ref3.iconStyle,
      restInputProps = _objectWithoutProperties(_ref3, _excluded);

  var _useState = useState(''),
      phoneNumber = _useState[0],
      setPhoneNumber = _useState[1];

  var _useState2 = useState(defaultCountry),
      selectedCountry = _useState2[0],
      setSelectedCountry = _useState2[1];

  var _useState3 = useState(''),
      phoneNumberWithCountryCode = _useState3[0],
      setPhoneNumberWithCountryCode = _useState3[1];

  useEffect(function () {
    if (selectedCountry && phoneNumber) {
      setPhoneNumberWithCountryCode("+".concat(getCountryCallingCode(selectedCountry)).concat(removeSpaces(phoneNumber)));
    }

    onChange && onChange(phoneNumberWithCountryCode);
  }, [onChange, phoneNumber, phoneNumberWithCountryCode, selectedCountry]);
  return /*#__PURE__*/_jsxs(Wrapper, {
    fullwidth: textInput === null || textInput === void 0 ? void 0 : textInput.isFullwidth,
    children: [/*#__PURE__*/_jsx(CountriesMenu, {
      value: selectedCountry,
      onChange: function onChange(country) {
        return setSelectedCountry(country);
      },
      wrapperStyle: [{
        "position": "absolute",
        "top": "8px",
        "left": "0.75rem",
        "zIndex": "10"
      }, countryMenuWrapperStyle || {}],
      variant: "phone",
      favorites: favorites,
      dropdownPlacementConfig: {
        crossAxis: -8,
        mainAxis: 8
      }
    }), /*#__PURE__*/_jsx(TextInput, _objectSpread({
      id: id,
      type: "tel",
      iconStyle: [{
        "position": "relative",
        "left": "68px"
      }, iconStyle || {}],
      inputStyle: textInput !== null && textInput !== void 0 && textInput.icon ? {
        "paddingLeft": "100px"
      } : {
        "paddingLeft": "78px"
      },
      value: formatPhoneNumber(phoneNumber),
      onChange: function onChange(phone) {
        return setPhoneNumber(function (prev) {
          return isNaN(+removeSpaces(phone)) ? prev : phone;
        });
      }
    }, restInputProps))]
  });
}
export default PhoneInput;
export function checkIsPhoneNumberValid(phoneNumber) {
  if (!phoneNumber) return false;
  return validatePhoneNumber(phoneNumber);
}

function formatPhoneNumber(phoneNumber) {
  if (phoneNumber.length > 3 && phoneNumber[3] !== ' ') {
    return phoneNumber.slice(0, 3) + ' ' + phoneNumber.slice(3);
  }

  return phoneNumber;
}

function removeSpaces(str) {
  return str.replace(/\s+/g, '');
}

var Wrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "phone-input__Wrapper",
  componentId: "sc-4rhery-0"
})(["", " ", ""], {
  "position": "relative",
  "width": "fit-content"
}, function (_ref4) {
  var fullwidth = _ref4.fullwidth;
  return fullwidth ? {
    "width": "100%"
  } : {};
});